/**
 * Format fleet/location complaint performance metrics (engine-aligned payloads).
 */

export const formatMetricTime = (days) => {
  if (days == null || Number.isNaN(Number(days))) {
    return 'N/A';
  }
  const n = Number(days);
  if (n < 1) {
    return (n * 24).toFixed(1) + 'h';
  }
  return n.toFixed(1) + 'd';
};

export const formatFleetMetricDays = (metric) => {
  if (!metric || !metric.count) {
    return 'N/A';
  }
  return formatMetricTime(metric.avg_days || 0);
};

/** Matches backend ACTIVE_COMPLAINT_STATUSES for complaint list filters */
export const ACTIVE_COMPLAINT_STATUSES = ['open', 'acknowledged', 'in_progress', 'escalated_to_vendor'];
export const ACTIVE_COMPLAINT_FILTER_STATUS = 'open,acknowledged,in_progress,escalated_to_vendor';
